export const faqData = [
  {
    id: 1,
    question: 'サプリメントはいつ飲むのが効果的ですか？',
    answer: '基本的には食後30分以内にお飲みいただくことをおすすめしています。食事と一緒に摂取することで、栄養素の吸収率が高まります。ただし、製品によって推奨される飲み方が異なる場合がありますので、各製品のラベルをご確認ください。',
  },
  {
    id: 2,
    question: '複数のサプリメントを同時に飲んでも大丈夫ですか？',
    answer: '当社の製品は併用していただいても問題ございません。ただし、他社製品との併用や、医薬品を服用されている場合は、かかりつけの医師や薬剤師にご相談いただくことをおすすめいたします。',
  },
  {
    id: 3,
    question: '妊娠中や授乳中でも飲めますか？',
    answer: '妊婦向けサプリメントは妊娠中・授乳中の方にも安心してお飲みいただけるよう設計されています。その他の製品につきましては、念のため医師にご相談の上、ご使用ください。',
  },
  {
    id: 4,
    question: 'アレルギーがあるのですが、原材料を確認できますか？',
    answer: 'すべての製品パッケージに原材料を詳細に記載しております。また、当社ウェブサイトの各商品ページでも原材料情報をご確認いただけます。ご不明な点がございましたら、お気軽にお問い合わせください。',
  },
  {
    id: 5,
    question: '賞味期限はどのくらいですか？',
    answer: '製品により異なりますが、未開封の状態で製造日から2年間が一般的です。開封後は湿気を避け、直射日光の当たらない涼しい場所で保管し、なるべく早めにお召し上がりください。',
  },
  {
    id: 6,
    question: '返品・交換は可能ですか？',
    answer: '未開封・未使用の商品に限り、商品到着後7日以内であれば返品・交換を承ります。お客様都合による返品の場合は送料をご負担いただきます。不良品の場合は送料当社負担で交換させていただきます。',
  },
];